import {Component, Input, OnInit} from '@angular/core';
import {IMessengerConnector, Message} from '../../../types/all.type';

@Component({
  selector: 'app-message-sender-partner',
  templateUrl: './message-sender-partner.component.html',
  styleUrls: ['./message-sender-partner.component.scss', '../message-sender/message-sender.component.scss']
})
export class MessageSenderPartnerComponent {
  @Input() message: Message;
  @Input() Service: IMessengerConnector;
  constructor() { }

}
